import React, { useEffect, useState } from 'react';
import { Button, Form, Input, message, Image } from 'antd';
import './../../css/Login.css';
import logo from './../../assets/logo.jpg';
import captchaImage from './../../assets/capcha.jpg'; // Đảm bảo đường dẫn tới hình ảnh captcha

const Login = ({ onLoginSuccess }) => {
  const [form] = Form.useForm();
  const [isRegistering, setIsRegistering] = useState(false); // Thêm trạng thái

  useEffect(() => {
    const savedUsername = localStorage.getItem('username');
    if (savedUsername) {
      form.setFieldsValue({ username: savedUsername });
    }
  }, [form]);

  const onFinish = async (values) => {
    try {
      const url = isRegistering ? `${process.env.REACT_APP_API_DB_URL}/register` : `${process.env.REACT_APP_API_DB_URL}/login`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values), // Gửi values bao gồm captcha
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      //console.log('Success:', data);

      if (!isRegistering) {
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('username', values.username);
        message.success('Login successful!',1);
        onLoginSuccess();
      } else {
        message.success('Registration successful! Please log in.');
        setIsRegistering(false); // Quay lại chế độ đăng nhập sau khi đăng ký thành công
      }
      
    } catch (error) {
      console.error('Failed:', error);
      message.error(isRegistering ? 'Registration failed!' : 'Login failed!');
    }
  };

  const onFinishFailed = (errorInfo) => {
  //  console.log('Failed:', errorInfo);
  };

  const toggleForm = () => {
    setIsRegistering(!isRegistering);
  };

  return (
    <div className="login-container">
      <div className="logo-container">
        <img src={logo} alt="Logo" style={{ width: '100%', maxWidth: '300px', marginBottom: '20px' }} />
      </div>
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Tài khoản"
          name="username"
          rules={[{ required: true, message: 'Please input your username!' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Mật khẩu"
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password />
        </Form.Item>

        {isRegistering && (
  <>
    {/* <Form.Item
      label="Xác nhận mật khẩu"
      name="confirmPassword"
      rules={[{ required: true, message: 'Please confirm your password!' }]}
    >
      <Input.Password />
    </Form.Item> */}

    <Form.Item label="Captcha">
      <Image
        width={200}
        src={captchaImage}
        alt="Captcha"
      />
    </Form.Item>
    <Form.Item
      label="Nhập captcha"
      name="captcha" // Đảm bảo có 'name' để form theo dõi
      rules={[{ required: true, message: 'Please enter the captcha!' }]}
    >
      <Input placeholder="Nhập captcha" />
    </Form.Item>
  </>
)}


        <Form.Item
          wrapperCol={{ offset: 8, span: 16 }}
        >
          <Button type="primary" htmlType="submit">
            {isRegistering ? 'Đăng ký' : 'Đăng nhập'}
          </Button>
          <Button type="link" onClick={toggleForm}>
            {isRegistering ? 'Đã có tài khoản? Đăng nhập' : 'Chưa có tài khoản? Đăng ký'}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;